import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InstagramHandle from 'components/InstagramHandle';
import LinkBox from 'components/LinkBox';
import LocationContactInfo from 'components/LocationContactInfo';
import SocialMedia from 'components/SocialMedia';
// import getWorkForUsPageLink from 'services/getWorkForUsPageLink';
import './index.scss';

/*
 * Types definition
 */
const propTypes = {
    location: PropTypes.shape({
        title: PropTypes.string,
        featuredImage: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
        ]),
        instagramHandle: PropTypes.string,
        instagramBackground: PropTypes.string,
        headquarter: PropTypes.bool,
        facebook: PropTypes.string,
        tripAdvisor: PropTypes.string,
        googleReview: PropTypes.string,
        locatorImageLogo: PropTypes.string,
        locatorImageThumbnail: PropTypes.string,
        orderUrl: PropTypes.string
    }),
};

const defaultProps = {
    location: null,
};

/*
 * Component
 */
function LocationDetails({ location }) {
    if (!location) {
        return null;
    }

    const {
        featuredImage,
        instagramHandle,
        instagramBackground,
        // headquarter,
        facebook,
        tripAdvisor,
        googleReview,
        locatorImageLogo,
        locatorImageThumbnail,
        orderUrl,
    } = location;

    // const linkBoxUrl = getWorkForUsPageLink(headquarter);
    // const linkBoxLabel = headquarter ? 'Acai HQ' : 'Acai Brothers';
    const linkBoxUrl = orderUrl;

    return (
        <section className="location-details">
            <SocialMedia
                facebookUrl={facebook}
                instagramUrl={instagramHandle && `https://www.instagram.com/${instagramHandle}`}
            />
            <div className="location-details-row">
                {featuredImage
                && (
                    <figure
                        className="featured-image"
                        style={{
                            backgroundImage: `url(${featuredImage})`,
                        }}
                    />
                )}
                <LocationContactInfo />
                <InstagramHandle
                    handle={instagramHandle}
                    backgroundImage={instagramBackground}
                    tripAdvisor={tripAdvisor}
                    googleReview={googleReview}
                />
                <LinkBox url={linkBoxUrl}>
                    <div className="order-container">
                        <img src={locatorImageThumbnail} className="order-thumbnail" alt="order thumbnail" />
                        <div className="order-container-inner">
                            <img className="order-logo" src={locatorImageLogo} alt="order logo" />
                            <h3>Order now online</h3>
                        </div>
                    </div>
                </LinkBox>
            </div>
        </section>
    );
}

const mapStateToProps = state => ({
    location: state.locations[state.currentLocation],
    workAtHQPage: state.workAtHQPage,
    workInStorePage: state.workInStorePage,
});

LocationDetails.propTypes = propTypes;
LocationDetails.defaultProps = defaultProps;

export default connect(mapStateToProps)(LocationDetails);
